export default __webpack_public_path__ + "static/media/polygon_logo.7c9a597c.svg";